import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'
import './home.css'
import LazyLoad from 'lazy-load'
import {gsap} from "gsap/dist/gsap"
import {login, logout} from 'auth'
import AnimateLoad from 'components/common/animate-load'
import {ISNZ} from '../../auth/constants'
import {getRegisterUrl} from 'app-config/environment'
import {readSignInFailure} from 'auth/signInFailure'

//[mh] INC1465998: same numbers and options as the error pages (components/error-pages/generic-error.js)
const SUPPORT_CONTACT = ISNZ
    ? 'contact our Support Team by email at mybusiness@canon.co.nz or on 0800 222 666 (select option 1 then option 3)'
    : 'contact our Support Team on 13 13 83 (select option 2)'

const SignInFailureNotice = ({failure, noticeRef}) => {
    const quote = failure.reference ? (
        <Fragment> and quote reference <strong>{failure.reference}</strong></Fragment>
    ) : null
    return (
        <div className="outage-banner" role="alert" tabIndex="-1" ref={noticeRef}>
            {failure.repeated ? (
                <Fragment>
                    We still couldn't complete your sign-in. Please {SUPPORT_CONTACT}{quote}. You can also select
                    Login to try again, or{' '}
                    <a role="button" tabIndex="0" onClick={() => logout()} onKeyPress={() => logout()}>
                        sign out and start again
                    </a>.
                </Fragment>
            ) : (
                <Fragment>
                    {failure.clock
                        ? "We couldn't complete your sign-in because your computer's date or time looks wrong. Please correct it (your IT team can help), then select Login to try again."
                        : "We couldn't complete your sign-in. Please select Login to try again."}{' '}
                    If this keeps happening, please {SUPPORT_CONTACT}{quote}.
                </Fragment>
            )}
            {failure.salesforce && ' You can also reopen the account from Salesforce.'}
        </div>
    )
}

class Home extends Component {

    constructor(props) {
        super(props)
        if (props) {
            this.state = {}
        }
        this.cards = []
        this.tl = gsap.timeline({paused: true})
        this.cycle = 0
        this.signInFailure = readSignInFailure()
    }

    componentDidMount() {
        if (this.signInFailure) {
            if (this.signInNotice) this.signInNotice.focus()
            // shown once: a refresh or a bookmark of the landing page must not repeat it
            window.history.replaceState(window.history.state, '', window.location.pathname)
        }
        if (this.props.account) {
        }
        LazyLoad.configureLazyLoadImages()
        this.tl.to(
            this.cards,
            1,
            {
                stagger: {
                    autoAlpha: 1,
                    repeat: 2,
                    yoyo: true,
                    repeatDelay: 20,
                    ease: 'easeInOut'
                }
            },
            21
        ).play()
        // console.log(ISNZ)
        this.setState({
            registerLink: getRegisterUrl(ISNZ),
            videoLink: ISNZ ? 'https://www.youtube.com/embed/yC3uyCeeZsI' : 'https://www.youtube.com/embed/f4fcyEimMP0?list=PLdjusQgp4g92l5YHr4_QSunzq1uyp-XJM',
            //to remotely set this change here
            displayOutageBanner: false,
        })
        this.cycle = setInterval(this.handleHeroAnimation, 75000)
        document.body.classList.add('home')
    }

    componentWillUnmount() {
        if (this.tl.isActive) {
            this.tl.pause()
            this.tl.kill()
        }
        clearInterval(this.cycle)
        document.body.classList.remove('home')
    }

    render() {
        return (
            <div className="mcb__home">
                <section className="hero posn__rel section-layout-1200 d-flex-aic clearfix">
                    <div
                        className="back-img posn__abs"
                        style={{backgroundImage: "url('/assets/img/hero-home-1.jpg')"}}
                    />
                    <div
                        className="back-img posn__abs img-hide"
                        style={{backgroundImage: "url('/assets/img/hero-home-1.jpg')"}}
                        ref={img => (this.cards[0] = img)}
                    />
                    <div
                        className="back-img posn__abs img-hide"
                        style={{backgroundImage: "url('/assets/img/hero-home-2.jpg')"}}
                        ref={img => (this.cards[1] = img)}
                    />
                    <div
                        className="back-img posn__abs img-hide"
                        style={{backgroundImage: "url('/assets/img/hero-home-3.jpg')"}}
                        ref={img => (this.cards[2] = img)}
                    />
                    <div className="back-grad posn__abs"/>
                    <div className="cols__1--2 px-16 hero-content">
                        <h1>MyCanon Business</h1>
                        <p className="my-16">
                            Manage your accounts with ease from our simple
                            online support hub.
                        </p>
                        <div className="rect-line mb-8"/>
                        <div className="fs-title pt-16">Your Business,</div>
                        <div className="fs-title pt-4">Your Time, Your Way</div>
                        {this.signInFailure && (
                            <SignInFailureNotice
                                failure={this.signInFailure}
                                noticeRef={node => (this.signInNotice = node)}
                            />
                        )}
                        <div className="buttons pt-32">
                            <a rel="noopener noreferrer"
                               role="button"
                               tabIndex="0"
                               className="fs-small btn__1-r mr-32 px-32 py-4"
                               onClick={() => login()}
                               onKeyPress={() => login()}
                            >
                                Login
                            </a>
                            <a
                                href={this.state.registerLink}
                                className="fs-small btn__1-r px-32 py-4"
                            >
                                Register
                            </a>
                        </div>
                        {this.state.displayOutageBanner && (
                            <div className="outage-banner">
                                We are currently experiencing an unexpected phone outage that is impacting our call
                                centres.
                                We are working urgently to resolve it. If you need to contact us in the meantime, please
                                email us via the <a href="https://www.canon.com.au/about-canon/contact-us"
                                                    target="_blank">contact
                                form on our website</a> or contact us via <a
                                href="https://www.canon.com.au/support?optionId=848DAF3EF0DE4CE3B0B996B2AA665844"
                                target="_blank">live chat</a> (a chat window will appear at the bottom of this page).
                                Reach out to us <a href="https://www.canon.com.au/support/order-toner-and-supplies-form"
                                                   target="_blank">here if you need to order toner or other
                                supplies</a> or <a
                                href="https://www.canon.com.au/support/business-service-and-repair-form?option=service&optionId=848DAF3EF0DE4CE3B0B996B2AA665844"
                                target="_blank">here to book a service</a>.
                                <br/>
                                <br/>
                                Your usual Canon contact can also be contacted via their mobile phone or email address.
                            </div>
                        )}

                    </div>
                </section>
                <section className="banner-w-icons posn__rel section-layout-1200 clearfix py-16">
                    <ul className="items text-center fs-small d-flex-jsb">
                        <li className="item">
                            <img
                                src="/assets/img/icon-usage-history.svg"
                                alt=""
                                className=""
                            />
                            <div>View asset usage history</div>
                        </li>
                        <li className="item">
                            <img
                                src="/assets/img/icon-techconnect.svg"
                                alt=""
                            />
                            <div>Schedule & track your technician requests</div>
                        </li>
                        <li className="item">
                            <img
                                src="/assets/img/icon-usage-charge.svg"
                                alt=""
                                className=""
                            />
                            <div>View & pay invoices</div>
                        </li>
                        <li className="item">
                            <img
                                src="/assets/img/icon-consumables.svg"
                                alt=""
                            />
                            <div>Order consumables</div>
                        </li>
                        <li className="item">
                            <img
                                src="/assets/img/icon-troubleshoot.svg"
                                alt=""
                                className=""
                            />
                            <div>View & troubleshoot assets</div>
                        </li>
                    </ul>
                </section>
                <section className="video-content posn__rel section-layout-1200">
                    <div className="text-center fs-title pt-16 pb-32">
                        See what you can do with MyCanon Business & TechConnect
                    </div>
                    <iframe
                        title="mcb"
                        width="100%"
                        height="600"
                        src={this.state.videoLink}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="pt-16 pb-32"
                    />
                </section>
                <section className="banner-techconnect clearfix py-32">
                    <div className="section-layout-1200 d-flex-jc py-32">
                        <div className="lhs">
                            <img
                                src="/assets/img/icon-techconnect-white.svg"
                                alt=""
                                className="icon-tc"
                            />
                        </div>
                        <div className="rhs">
                            <div className="fs-title">
                                Experience{' '}
                                <img
                                    src="/assets/img/icon-techconnect-wtext.svg"
                                    alt=""
                                    className="icon-tc-text"
                                />
                            </div>
                            <p>
                                A handy tool that lets you book and receive
                                status updates on your tech services
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        account: state.account.selectedAccount
    }
}

export default AnimateLoad(
    connect(
        mapStateToProps,
        null
    )(Home)
)
